import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PayloadMapping, PayloadMappingCreate, PayloadMappingFilter } from '../data/payloadMapping';

export function createPayloadMappingService(client: AxiosInstance) {
  return createCrudService<PayloadMapping, PayloadMappingCreate, PayloadMappingFilter>(
    client,
    '/integration/PayloadMapping',
    'id',
  );
}

export type PayloadMappingService = CrudService<PayloadMapping, PayloadMappingCreate, PayloadMappingFilter>;
